import React from "react";
import RegisterForShares from "./RegisterForShares";

const SignUpForG5 = () => {
  return <RegisterForShares />;
};

export default SignUpForG5;
